import Section from './Section'
import SectionHead from './SectionHead'

// The band that closes a page: one line, an optional lead, the one action.
// Every page ends with this, so the last thing on every page is the same shape.
//
// Ground follows the page: a trunk home closes on navy (buttons must then be
// variant="light"), an inner page closes on the canvas.

export default function CtaBand({ ground = 'canvas', size = 'lg', title, lead, children }) {
  return (
    <Section ground={ground}>
      <SectionHead
        title={title}
        lead={lead}
        size={size}
        on={ground === 'navy' ? 'navy' : 'light'}
        align="center"
        className="max-w-[680px]"
      />
      {children && <div className="mt-8 flex flex-wrap items-center justify-center gap-3">{children}</div>}
    </Section>
  )
}
